import { useNavigate } from "react-router-dom"
import MTable from "../../../../components/mtable"

export default function Sparks() {

    const navigate = useNavigate()
    const create = () => navigate('sparks/create')

    const sparksMapper = {columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Description",
            value: (item) => item.description,
            width: '2fr'
        },
        {
            label: "Content ID",
            value: (item) => item.contentId
        }
    ]}

    const details = (spark) => navigate(`sparks/${spark.id}`)

    return(<>
        <div className="flex space-between gap-xs v-spacer-m">
            <p className="section-title">Sparks</p>
            <button className="solid" onClick={create}>Create Spark</button>
        </div>
        <MTable path={'sparks'} mapper={sparksMapper} onClick={details}/>
    </>)
}